export default "__VITE_ASSET__D$kc8K4D__"